import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\toutline: none;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: rgba(0, 0, 0, 0.8);\n\tborder-radius: 6px;\n\tbox-shadow: 0 0 0 1px rgba(255, 255, 255, 0.04);\n\tcolor: ", ";\n\tpadding: 4px 8px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbox-sizing: border-box;\n\topacity: 0;\n\toutline: none;\n\ttransform-origin: top center;\n\ttransition: opacity ", " ease;\n\n\t&[data-enter] {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var TooltipContent = css(_templateObject(), ui.zIndex('Tooltip'), ui.get('transitionDurationFastest'));
export var TooltipPopoverView = styled.div(_templateObject2(), ui.color.white);
export var noOutline = css(_templateObject3());